import React, { useState, useEffect, useRef } from "react";
import ReactPlayer from "react-player";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { Carousel } from "react-responsive-carousel";
import "../Pages/Css/carousel.css";
import axios from "../utils/axiosConfig";

const VideoGallery = ({ contrato }) => {
  const [videos, setVideos] = useState([]);
  const [selectedItem, setSelectedItem] = useState(0);
  const [showAlert, setShowAlert] = useState(true);
  const videoRefs = useRef([]);

  const handleVideoSelect = (index) => {
    setSelectedItem(index);
    if (videos[index]) {
      mostrarInfo(videos[index]);
    }
  };

  useEffect(() => {
    getVideos(contrato);
    setShowAlert(true);
  }, [contrato]);

  const getVideos = async (selectedContrato) => {
    try {
      setSelectedItem(0);
      const infojson = document.getElementById("infojson");
      if (infojson) infojson.innerHTML = "";

      const data = { contrato: selectedContrato, tipo: "vid" };
      const json = JSON.stringify(data);

      if (selectedContrato !== -1) {
        const response = await axios.post(
          process.env.REACT_APP_SERVER + "/operaciones/getfotoscontrato",
          json,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
            withCredentials: true,
          }
        );

        if (response.data.success) {
          setVideos(response.data.data || []);
          if ((response.data.data || []).length > 0) {
            mostrarInfo(response.data.data[0]);
          } else {
            const infovideo = document.getElementById("infovideo");
            if (infovideo) infovideo.innerHTML = "Sin Información disponible";
          }
        } else {
          window.history.go(0);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const saveVideoRef = (index) => (ref) => {
    videoRefs.current[index] = ref;
  };

  const loadVideosData = (list) => {
    if (list.length > 0) {
      return list.map((video, index) => (
        <div key={index} className="video-gallery-slide">
          <ReactPlayer
            ref={saveVideoRef(index)}
            className="video-gallery-player"
            url={video.Source}
            width="100%"
            height={480}
            controls
            light={video.previewImage}
            playsinline
            playing={index === selectedItem}
          />
        </div>
      ));
    }

    return (
      <div key={-1} className="video-gallery-empty-main">
        <div className="video-gallery-empty-card">
          <div className="video-gallery-empty-icon">▣</div>
          <h4>Sin videos disponibles</h4>
          <p>Aun no hay evidencia multimedia asociada a este contrato.</p>
        </div>
      </div>
    );
  };

  const loadThumbnails = (list) => {
    if (list.length > 0) {
      return list.map((video, index) => (
        <div
          key={index}
          className={`video-thumb ${index === selectedItem ? "selected" : ""}`}
          onClick={() => handleVideoSelect(index)}
        >
          <video src={video.Source} />
        </div>
      ));
    }

    return <p className="video-gallery-empty-thumbs">No hay miniaturas disponibles</p>;
  };

  const mostrarInfo = (video) => {
    const infovideo = document.getElementById("infovideo");
    if (!infovideo || !video) return;

    infovideo.innerHTML = `${video.Evento}<br/>${video.Descripcion}<br/>${video.Latitud} , ${video.Longitud}<br/>${video.Nombreempresa}<br/>${video.Hora}`;
  };

  return (
    <div className="video-gallery-modern">
      {showAlert && (
        <MDBRow className="video-gallery-alert-row">
          <MDBCol>
            <div className="video-gallery-alert">
              <p>Recuerda porfavor pausar el video antes de abandonar el modal</p>
              <button className="btn-close" onClick={() => setShowAlert(false)}></button>
            </div>
          </MDBCol>
        </MDBRow>
      )}

      <MDBRow className="video-gallery-layout">
        <MDBCol md="9" className="video-gallery-main mb-4">
          <div className="video-gallery-player-card">
            <Carousel
              selectedItem={selectedItem}
              showThumbs={false}
              showArrows={true}
              showStatus={false}
              showIndicators={false}
              infiniteLoop={false}
              onChange={handleVideoSelect}
            >
              {loadVideosData(videos)}
            </Carousel>
          </div>

          <div className="video-gallery-thumbnails-card">
            <div className="thumbnails">{loadThumbnails(videos)}</div>
          </div>
        </MDBCol>

        <MDBCol id="panelinfo" md="3" className="video-gallery-side">
          <div className="video-gallery-side-title">Información</div>
          <div id="infovideo" className="video-gallery-panel-content"></div>

          <div className="video-gallery-side-title">
            Image Analytics
            <img src="/images/reload.png" alt="Icono" className="video-gallery-reload" />
          </div>
          <div id="infojson" className="video-gallery-panel-content video-gallery-panel-content-scroll"></div>
        </MDBCol>
      </MDBRow>
    </div>
  );
};

export default VideoGallery;


